import type { ApiParams, AptiRequestConfig } from "@/lib/types/api";
import { httpAuth } from "@/utils/axios";
import type { InsuranceListResponse } from "@/features/insurance/types";
import type { PolicyConsentPayloadDTO, Profile, ProfileUpdatePayload } from "@/core/types";

export type AppendPatientConsentResponse = {
  message: string;
};

export const patientRequestsTyped = {
  append_patient_consent: function ({
    data,
    params,
  }: {
    data: PolicyConsentPayloadDTO;
    params?: Record<string, unknown>;
  }) {
    const config = {
      data,
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: "/v1/patient/append_consent",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AppendPatientConsentResponse>;
  },

  get_insurance_list: function ({
    params,
  }: {
    params?: ApiParams;
  } = {}): Promise<InsuranceListResponse> {
    const config = {
      method: "POST",
      params,
      url: "/v2/patient/insurance",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<InsuranceListResponse>;
  },

  update_profile: function ({ data }: { data: ProfileUpdatePayload }) {
    const config = {
      data,
      method: "POST",
      url: "/v1/patient/update_profile",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<Profile>;
  },
};
